import { Images } from "@/assets/images1";
import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const CommercialIntroStepPage = () => {
  return (
    <div className={stepStyles.commercialIntro}>
      <div className={stepStyles.heroImageWrap}>
        <img
          src={Images.andyHoldingSign}
          alt="Andy holding sign"
          className={stepStyles.heroImage}
        />
      </div>
      <h3 className={stepStyles.commercialIntroTitle}>
        Commercial Property Protest Documents Filing Process
      </h3>
      <p className={stepStyles.commercialIntroDescription}>
        We&apos;ll guide you through a simple step-by-step process to file your additional or
        supporting property documents.
      </p>

      <div className={stepStyles.commercialIntroStepsCard}>
        <p className={stepStyles.commercialIntroStep}>Step 1: Upload Pictures of Property</p>
        <p className={stepStyles.commercialIntroStep}>Step 2: Upload Rent Roll</p>
        <p className={stepStyles.commercialIntroStep}>Step 3: Upload Income/Expense Statement</p>
        <p className={stepStyles.commercialIntroStep}>Step 4: Upload Future Expenditures</p>
        <p className={stepStyles.commercialIntroStep}>Step 5: Upload Appraisal</p>
        <p className={stepStyles.commercialIntroStep}>Step 6: Review &amp; Submit</p>
      </div>

      <p className={stepStyles.commercialIntroReminder}>
        <strong>REMINDER:</strong> To successfully protest your commercial property taxes,
        we&apos;ll need you to upload documentation about your property including pictures, rent
        roll, income/expense statements, and any future expenditure plans. This information helps us
        build a strong case for reducing your taxable value.
      </p>
    </div>
  );
};
